import React, { Component } from "react";
import Checkbox from "../../../../shared/Checkbox/Checkbox";
import Button from "../../../../shared/button/button";
import UploadFile from "../../../../shared/UploadFile/UploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
	onApproveInvite,
	setDataToStoreParticipant,
	onSendingFile
} from "./../../../actions/account-link";
import { getUploadFileURL } from "../../../shared/multi-accounts-requests-api";
import { MULTICONTA_INVITATION_EXPIRATION_DAYS } from "../../../../../js/shared/constants";
import axios from "axios";

class AccountLinkUploadFiles extends Component {
	constructor() {
		super();
		this.state = {
			signedUrls: [],
			idFrontFile: undefined,
			idBackFile: undefined,
			selfieFile: undefined,
			declarationFile: undefined
		};

		this.setFile = this.setFile.bind(this);
		this.sendFile = this.sendFile.bind(this);
		this.nextStep = this.nextStep.bind(this);
		this.prevStep = this.prevStep.bind(this);
	}

	componentDidMount() {
		const { data } = this.props;
		let self = this;

		getUploadFileURL(data.relationId).then(response => {
			self.setState({ signedUrls: response.data });
		});
	}

	isValid() {
		const {
			frontAndBack,
			idFrontFile,
			idBackFile,
			selfieFile,
			declarationFile,
			idFront,
			idBack,
			selfie,
			declaration
		} = this.state;
		return (
			idFront &&
			idFrontFile &&
			(frontAndBack || (idBack && idBackFile)) &&
			selfie &&
			selfieFile &&
			declaration &&
			declarationFile
		);
	}

	dataURLtoFile(dataurl, filename) {
		let arr = dataurl.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, { type: mime });
	}

	sendFile(signedUrl, file) {
		const self = this;
		// Put the fileType in the headers for the upload
		const options = {
			headers: {
				"Content-Type": "image/png"
			}
		};
		axios
			.put(signedUrl, file, options)
			.then(result => {
				self.props.onSendingFile(-1);
			})
			.catch(error => {
				// alert("ERROR " + JSON.stringify(error)); //remover
				location.reload();
			});
	}

	setFile(file, type) {
		const { signedUrls } = this.state;
		let self = this;
		let dataurl = "";
		let signedUrl = signedUrls.find(sUrl => sUrl.type == type);

		let reader = new FileReader();
		reader.onload = e => {
			let img = document.createElement("img");
			img.onload = () => {
				let canvas = document.createElement("canvas");
				let ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0);

				let MAX_WIDTH = 800;
				let MAX_HEIGHT = 800;
				let width = img.width;
				let height = img.height;

				if (width > height) {
					if (width > MAX_WIDTH) {
						height *= MAX_WIDTH / width;
						width = MAX_WIDTH;
					}
				} else {
					if (height > MAX_HEIGHT) {
						width *= MAX_HEIGHT / height;
						height = MAX_HEIGHT;
					}
				}
				canvas.width = width;
				canvas.height = height;
				ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0, width, height);
				dataurl = canvas.toDataURL("image/png");
				let correctFile = self.dataURLtoFile(dataurl, type + ".png");
				self.sendFile(signedUrl.url, correctFile);
			};
			img.src = e.target.result;
		};
		if (file) {
			this.props.onSendingFile(1);
			reader.readAsDataURL(file);
		}

		this.setState({
			[type + "File"]: file,
			[type]: {
				// file,
				type,
				key: signedUrl.key
			}
		});

		return {
			type,
			key: signedUrl.key
		};
	}

	nextStep() {
		const { frontAndBack, idFront, idFrontFile, selfie, declaration } = this.state;
		const { data } = this.props;
		let idBack = this.state.idBack;
		if (frontAndBack) {
			idBack = this.setFile(idFrontFile, "idBack");
		}

		this.props.setDataToStoreParticipant({
			idFront,
			idBack,
			selfie,
			declaration
		});
		this.props.incStep(this.state);
	}

	prevStep() {
		this.props.decStep(this.state);
	}

	render() {
		const { frontAndBack, front, back, selfie, declaration } = this.state;
		const { dataApproveInvite } = this.props;
		let optionFrontAndBack = [
			{
				label: <span>O arquivo tem frente e verso do documento</span>,
				name: "frontAndBack",
				checked: frontAndBack
			}
		];

		return (
			<React.Fragment>
				<div className="account-link-upload-files--details">
					<h4>Envio de documentos digitalizados</h4>
					<p>
						Nesta etapa, você deverá digitalizar e fazer upload dos documentos necessários para
						solicitar a vinculação da sua conta. Os arquivos devem estar nos formatos jpg ou png e
						ter até 5 MB cada um deles.
					</p>
					<p>
						Mas atenção! Você tem até <strong>{MULTICONTA_INVITATION_EXPIRATION_DAYS}</strong> para concluir
						esta etapa. Depois desse prazo, a indicação irá se expirar e terá que ser iniciada
						novamente.
					</p>
					<div className="account-link-upload-files--uploads">
						<div className="row">
							<div className="col-xs-16">
								<label>Documento com foto (frente)</label>
							</div>
							<div className="col-xs-16 col-md-6 col-upload">
								<UploadFile
									onChange={file => this.setFile(file, "idFront")}
									accept="image/png,image/jpeg"
								>
									Escolher arquivo
								</UploadFile>
							</div>
							<div className="col-xs-16 col-md-6">
								<Checkbox
									id="frontAndBack"
									name="frontAndBack"
									onChange={options =>
										this.setState({ frontAndBack: options[0].checked, idBackFile: undefined })
									}
									options={optionFrontAndBack}
								/>
							</div>
						</div>
						{!frontAndBack ? (
							<div className="row">
								<div className="col-xs-16">
									<label>Documento com foto (verso)</label>
								</div>
								<div className="col-xs-16 col-md-6 col-upload">
									<UploadFile
										onChange={file => this.setFile(file, "idBack")}
										accept="image/png,image/jpeg"
										disabled={!this.state.idFront}
									>
										Escolher arquivo
									</UploadFile>
								</div>
								<div className="col-xs-16 col-md-6">
									<p>
										Confira se a imagem <br /> digitalizada está nítida.
									</p>
								</div>
							</div>
						) : null}
						<div className="row">
							<div className="col-xs-16">
								<label>Selfie com documento</label>
							</div>
							<div className="col-xs-16 col-md-6 col-upload">
								<UploadFile
									onChange={file => this.setFile(file, "selfie")}
									accept="image/png,image/jpeg"
									disabled={frontAndBack ? !this.state.idFront : !this.state.idBack}
								>
									Escolher arquivo
								</UploadFile>
							</div>
							<div className="col-xs-16 col-md-6">
								<p>
									Faça uma foto sua segurando,<br />ao lado do rosto, a parte da <br />
									frente do documento de identificação.
								</p>
							</div>
						</div>
						<div className="row">
							<div className="col-xs-16">
								<label>Declaração de Vínculo assinada</label>
							</div>
							<div className="col-xs-16 col-md-6 col-upload">
								<UploadFile
									onChange={file => this.setFile(file, "declaration")}
									accept="image/png,image/jpeg"
									disabled={!this.state.selfie}
								>
									Escolher arquivo
								</UploadFile>
							</div>
							<div className="col-xs-16 col-md-6">
								<p>
									Atenção! A assinatura da <br /> declaração precisa ser <br /> exatamente igual a
									do documento <br /> enviado por você.
								</p>
							</div>
						</div>

						<hr />

						<p>
							Você pode escanear ou fotografar seus documentos, combinado? Lembre que as imagens não
							podem estar cortadas e os textos devem estar totalmente legíveis.{" "}
						</p>
					</div>
				</div>

				<div className="row row-botoes">
					<div className="col-xs-16 text-right">
						<Button className="btn btn-cancel" onClick={this.prevStep} type="button">
							Cancelar
						</Button>
						<Button
							className="btn btn-primary confirm-button btn-next"
							disabled={!this.isValid()}
							onClick={this.nextStep}
							type="button"
						>
							Avançar
						</Button>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	...state.AccountLink,
	data: state.accountLink.dataToSendParticipant
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			onApproveInvite,
			setDataToStoreParticipant,
			onSendingFile
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AccountLinkUploadFiles);
